import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Typography, Box, Chip, Grid, TextField, Radio, RadioGroup, FormControlLabel } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { setSelectedProductId, setFoodcompositionAddFoodCompModal } from "store/slice/PharmaSlice";
import { setOrderType } from "store/slice/AppSlice";
import { getCompositiontemplateInfoByTitleAPI } from "components/compositiontemplate/CompositiontemplateAPI";
import { getListAPI as getProductList } from "components/product/ProductAPI";
import { getProductInfoByPartyidAPI } from "components/product/ProductAPI";
import { setSelectedCTid } from "store/slice/AppSlice";
import AddFoodCompActionModal from "components/foodcomposition/action/AddFoodComp/AddFoodCompActionModal";
import { getListAPI as getFoodCompList } from "components/foodcomposition/FoodcompositionAPI";
import { setFoodcompositionList, setSelectedFoodcompositionId } from "store/slice/PharmaSlice";

export default function SelectFoodCompositionTemplate({ sectionHeight }) {
  const dispatch = useDispatch();
  const [foodCompositionId, setFoodCompositionId] = useState(null);
  const [filter, setFilter] = useState("");
  const [compositionType, setCompositionType] = useState("Drug");
  const {foodcompositionList} = useSelector((state) => state.pharmaslice);
  const {productObj} = useSelector((state) => state.pharmaslice.productDashboard);
  const {foodcompositionObj} = useSelector((state) => state.pharmaslice.foodcompositionDashboard);

  useEffect(() => {
    if (foodcompositionList && foodcompositionList.length === 0){
    getFoodCompList(()=>{}, 
      (data) => {
        dispatch(setFoodcompositionList(data));
      });
    }
      
  }, []);

  useEffect(()=>{
    if (foodcompositionObj && foodcompositionObj.id) {
      setFoodCompositionId(foodcompositionObj.id);
    }
    else {
      setFoodCompositionId(null);
      dispatch(setSelectedFoodcompositionId(null));
    }
  },[foodcompositionObj]);

  useEffect(()=>{
    if (productObj && productObj.ctid) {
      setFoodCompositionId(productObj.ctid);
    }
  },[productObj])


  const handleFoodCompositionClick = (id) => {
    console.log("Selected FOOD Composition ID:", id);
    setFoodCompositionId(id);
    dispatch(setSelectedFoodcompositionId(id));
  };

  return (

    <Grid container direction="row" justifyContent="space-between" alignItems="center" sx={{ width: "100%" }}>
      <Grid lg={12} xs={8} item sx={{ padding: 1, backgroundColor: 'white', paddingBottom: 1,}}>
        <TextField
          label="Filter Food Composition"
          variant="outlined"
          size="small"
          value={filter}
          onChange={e => setFilter(e.target.value)}
          sx={{ width: '100%' }}
          InputProps={{
            startAdornment: (
              <SearchIcon sx={{ color: 'action.active', mr: 1 }} />
            ),
          }}
        />
        </Grid>
        {/* <Grid lg={2} xs={4} item sx={{ padding: 1, backgroundColor: 'white', display: "flex", justifyContent: "flex-start", flexDirection: "column" }}>
          <Button variant="text" onClick={()=>dispatch(setFoodcompositionAddFoodCompModal(true))}>Add Food Composition</Button>
      </Grid> */}
      <Grid item lg={12} xs={12} sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
        <Box sx={{ backgroundColor: 'white', flex: 1, display: "flex", alignItems: "center", justifyContent: "flex-start", width: "100%" }}>
          <Grid item lg={12} xs={12} sx={{ overflowY: "scroll", backgroundColor: 'white', minHeight: sectionHeight, maxHeight: sectionHeight, }}>
            <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ width: "100%" }}>
              {foodcompositionList && foodcompositionList.length > 0 ? (
                [...foodcompositionList]
                  .filter(foodCompositionObj => foodCompositionObj.title.toLowerCase().includes(filter.toLowerCase()))
                  .sort((a, b) => a.title.localeCompare(b.title))
                  .map((foodCompositionObj) => {
                    return (
                      <Grid
                        lg={4}
                        md={6}
                        sm={3}
                        xs={12}
                        item
                        key={foodCompositionObj.id}
                        sx={{
                          width: '100%',
                          margin: 1,
                          backgroundColor: 'primary.lighter',
                          borderRadius: 1,
                          padding: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          border: '2px solid transparent',
                          opacity: 1,
                          transition: 'border-color 0.2s',
                          '&:hover': {
                            borderColor: 'primary.light'
                          },
                        }}
                      >
                        <Radio
                          checked={foodCompositionId === foodCompositionObj.id}
                          onChange={() => handleFoodCompositionClick(foodCompositionId == foodCompositionObj.id ? null : foodCompositionObj.id)}
                          value={foodCompositionObj.id}
                          color="primary"
                          sx={{ mr: 1 }}
                        />
                        <Typography
                          variant="h6"
                          className="party-title"
                          onClick={() => handleFoodCompositionClick(foodCompositionId == foodCompositionObj.id ? null : foodCompositionObj.id)}
                          sx={{
                            cursor: "pointer",
                            wordBreak: "break-word",
                            whiteSpace: "normal",
                            overflowWrap: "break-word",
                            maxWidth: "90hw", // Responsive max width for mobile/tablet/desktop
                            fontSize: { xs: 14, sm: 16 }, // Smaller font on mobile
                          }}
                        >
                          {foodCompositionObj.title}
                        </Typography>
                      </Grid>
                    );
                  })
              ) : (
                <Box
                  sx={{
                    minWidth: 200,
                    minHeight: 200,
                    backgroundColor: 'secondary.100',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 2,
                    width: '80%',
                    m: 2

                  }}
                >
                  <Typography variant="h5" color="text.secondary" sx={{}}>
                    Food Composition not found for the given filter. Please try again.
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <AddFoodCompActionModal />
    </Grid>
    
  );
}